import Hero from "../../components/Hero";
import CalculatorsImag1 from "../../../assets/images/Calculator1.jpg";
import EquityReleaseCalculator from "../../calculators/EquityReleaseCalculator";

const EquityReleasePage = () => {
  return (
    <div>
      <Hero
        title="Equity Release"
        subtitle=""
        backgroundImage={CalculatorsImag1}
      />
      <EquityReleaseCalculator />
      {/* <div className="landing-page">
            </div> */}
    </div>
  );
};

export default EquityReleasePage;
